import * as types from './types';

export const changeSaveDashboardPromptVisibility = (flag, id) => ({
  type: types.SAVE_DASHBOARD_PROMPT_VISIBILITY,
  flag,
  id,
});

export const toggleUpdatePopupVisible = (visible, id) => ({
  type: types.TOGGLE_UPDATE_POPUP_VISIBLE,
  visible,
  id,
});

export const setActiveDashboardId = id => ({
  type: types.SET_ACTIVE_DASHBOARD_ID,
  id,
});

export const toggleRemovePopupVisible = () => ({ type: types.TOGGLE_REMOVE_POPUP_VISIBLE });

export default changeSaveDashboardPromptVisibility;
